import { GetAppConfigQuery } from '@ocx/graphql';
import { OrderAheadProviderConfiguration } from '../app-config.types';

export const mapOrderAheadConfigurationProviderFragment = (
  orderAheadProviderFragment: NonNullable<GetAppConfigQuery['appConfig']['orderAhead']>['provider'],
): OrderAheadProviderConfiguration | null => {
  if (orderAheadProviderFragment.__typename === 'OrderAheadConfigurationProviderVroom') {
    return {
      type: 'vroom',
      ...orderAheadProviderFragment,
    };
  }

  if (orderAheadProviderFragment.__typename === 'OrderAheadConfigurationProviderOlo') {
    return {
      type: 'olo',
      ...orderAheadProviderFragment,
    };
  }

  if (orderAheadProviderFragment.__typename === 'OrderAheadConfigurationProviderLula') {
    return {
      type: 'lula',
      ...orderAheadProviderFragment,
    };
  }

  return null;
};
